import { COLOR1, COLOR4, RADIO_COLOR, WHITE } from '../../constants';

export const ProductQuestionModalStyle = {
  productmodalclose: {
    width: '25px',
    height: '25px',
  },

  productmodalcontainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  productmodal: {
    outline: 'none',
  },

  backdrop: {
    zIndex: 1301,
    color: WHITE,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
  },

  root: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '332px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 12px rgba(62, 64, 70, 0.08)',
    borderRadius: '10px',
    '@media (max-width:400px)': {
      maxHeight: 'unset',
    },
  },

  card_content: {
    textAlign: 'center',
    padding: '0px !important',
    margin: '0px',
    justifyContent: 'center',
    alignItems: 'center',
  },

  saveAndExit: {
    letterSpacing: '0.1px',
    font: 'normal 700 14px/16px Arial',
    width: '136px',
    height: '44px',
    margin: '17px 0 30px 0',
    opacity: 1,
    textTransform: 'none',
    borderRadius: '56px',
  },

  textOneStyle: {
    fontWeight: 700,
    letterSpacing: '0.12px',
    marginTop: '42px',
    marginLeft: '26px',
    marginRight: '26px',
  },

  textTwoStyle: {
    letterSpacing: '0.1px',
    marginTop: '20px',
    marginLeft: '26px',
    marginRight: '26px',
  },

  close_icon: {
    width: '34px',
    height: '34px',
    cursor: 'pointer',
    margin: '5px 5px 0 0',
  },

  modal_close: {
    color: RADIO_COLOR,
    textAlign: 'right',
    height: '35px',
  },

  closeOverlay: {
    padding: 0,
    top: '29px',
    color: COLOR4,
    width: '44px',
    cursor: 'pointer',
    height: '28px',
    position: 'relative',
  },
};
